/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import { getWorkOrders, getWorkOrder, printWorkOrder, createWorkOrders, updateWorkOrders, deleteWorkOrders } from "Modules/work_orders/config/api.work_orders";

const state = {
    page: {},
    form: {},
    work_orders: [],
    work_order_options: [],
    dashboard_work_orders: [],
    selectedWorkOrder: {
        id: null,
        company_id: "",
        work_order_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        work_order_details: [],
    },
    work_orders_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
        device_id: "",
        status: "",
    },
    rules_work_orders: {
        id: {
            name: "id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        device_id: {
            name: "device_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        wo_number: {
            name: "wo_number",
            rules: "trim|max_length[20]",
            max_len: "20",
            min_len: "",
            default_value: "",
        },
        inbound_tracking_number: {
            name: "inbound_tracking_number",
            rules: "trim|max_length[45]",
            max_len: "45",
            min_len: "",
            default_value: "",
        },
        reason_for_return: {
            name: "reason_for_return",
            rules: "trim",
            max_len: "16777215",
            min_len: "",
            default_value: "",
        },
        return_address: {
            name: "return_address",
            rules: "trim",
            max_len: "16777215",
            min_len: "",
            default_value: "",
        },
        contact_name: {
            name: "contact_name",
            rules: "trim|max_length[45]",
            max_len: "45",
            min_len: "",
            default_value: "",
        },
        country_id: {
            name: "country_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        contact_phone: {
            name: "contact_phone",
            rules: "trim|max_length[16]",
            max_len: "16",
            min_len: "",
            default_value: "",
        },
        contact_phone_formatted: {
            name: "contact_phone_formatted",
            rules: "trim|max_length[24]",
            max_len: "24",
            min_len: "",
            default_value: "",
        },
        contact_email: {
            name: "contact_email",
            rules: "trim|max_length[65]|valid_email",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        warranty_repair: {
            name: "warranty_repair",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        zoho_estimate_id: {
            name: "zoho_estimate_id",
            rules: "trim|max_length[45]|required",
            max_len: "45",
            min_len: "",
            default_value: "",
        },
        work_performed: {
            name: "work_performed",
            rules: "trim",
            max_len: "16777215",
            min_len: "",
            default_value: "",
        },
        outbound_tracking_number: {
            name: "outbound_tracking_number",
            rules: "trim|max_length[45]",
            max_len: "45",
            min_len: "",
            default_value: "",
        },
        date_performed: {
            name: "date_performed",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        performed_by: {
            name: "performed_by",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        wo_requested_by: {
            name: "wo_requested_by",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        private_notes: {
            name: "private_notes",
            rules: "trim",
            max_len: "16777215",
            min_len: "",
            default_value: "",
        },
        status_id: {
            name: "status_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        outbound_carrier_id: {
            name: "outbound_carrier_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    work_orders: (state) => {
        return state.work_orders;
    },
};

// actions
const actions = {
    async fetchWorkOrders({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getWorkOrders({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "work_order_options",
                        with: response.data.work_orders,
                    });

                    if (body.dashboard == true) {
                        commit("mutate", {
                            property: "dashboard_work_orders",
                            with: response.data.work_orders,
                        });
                    }
                } else {
                    commit("mutate", {
                        property: "work_orders",
                        with: response.data.work_orders,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchWorkOrder({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getWorkOrder(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedWorkOrder",
                    with: response.data.work_order,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printWorkOrder({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printWorkOrder(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveWorkOrder({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["id"] === "undefined" || body["id"] == null || body["id"] == "") {
                delete body["id"];
                response = await createWorkOrders({ body: body, headers: config.headers });
            } else {
                let id = body["id"];
                delete body["id"];
                response = await updateWorkOrders({ body: body, headers: config.headers }, id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteWorkOrder({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteWorkOrders(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
